import React, { useEffect, useRef, useState } from 'react';
import { Preset, Text } from '@lux/text';
import { useColorMode, getThemeColor } from '@lux/theme';
import { ControlsCloseS } from '@lux/icons';
import { ButtonColor, ButtonType } from '@lux/buttons';
import { Voucher } from '@lux/graphics';
import { useOnScreen } from '../../useOnScreen';
import { InfoWrapper, DescriptionText, CloseButton, DescriptionButton, TextButtonWrapper, TextWrapper, StyledVoucherBanner, IconWrapper, ButtonWrapper, } from './styles';
const Banner = ({ text, title, linkText, onCloseBanner, onLinkClick, color, icon: Icon = React.createElement(Voucher, null), descriptionTextTop = false, descriptionTextBottom = true, onVisible, ...props }) => {
    const theme = useColorMode();
    // @ts-ignore
    const themeColor = getThemeColor(theme)(color);
    const ref = useRef();
    const isOnScreen = useOnScreen(ref);
    const [isVisibleOnce, setIsVisibleOnce] = useState(false);
    useEffect(() => {
        if (isOnScreen && !isVisibleOnce) {
            onVisible();
            setIsVisibleOnce(true);
        }
    }, [isOnScreen, isVisibleOnce]);
    return (
    // @ts-ignore
    React.createElement(StyledVoucherBanner, { theme: theme, ...props, color: themeColor, ref: ref },
        React.createElement(InfoWrapper, null,
            React.createElement(IconWrapper, null, Icon),
            React.createElement(TextWrapper, null,
                React.createElement(DescriptionText, null,
                    React.createElement(Text, { preset: Preset.XS, presetMd: Preset.S, bold: true }, title),
                    ' ',
                    descriptionTextTop && (React.createElement(Text, { preset: Preset.XS, presetMd: Preset.S }, text))),
                React.createElement(TextButtonWrapper, null,
                    React.createElement(DescriptionText, null, descriptionTextBottom && (React.createElement(Text, { preset: Preset.XS, presetMd: Preset.S }, text))),
                    linkText && (React.createElement(ButtonWrapper, null,
                        React.createElement(DescriptionButton, { buttonType: ButtonType.tertiary, color: ButtonColor.dark, onClick: onLinkClick },
                            React.createElement(Text, { preset: Preset.XS, presetMd: Preset.S, bold: true }, linkText)))))),
            React.createElement("div", null,
                React.createElement(CloseButton, { onClick: onCloseBanner, onKeyPress: onCloseBanner, "aria-label": "Close", tabIndex: -1, type: "button" },
                    React.createElement(ControlsCloseS, { "aria-hidden": "true" }))))));
};
export default Banner;
//# sourceMappingURL=component.js.map